import uuid from "uuid";

export default {
    namespaced: true,
    state     : () => ({
        modals         : [],
        modalsContainer: null,
        modalsState    : {},
        availableModals: {}
    }),
    mutations : {
        pushModal(state, modal) {
            state.modals.push(modal);
        },
        setModalContainer(state, container) {
            state.modalsContainer = container;
        },
        deleteModal(state, id) {
            state.modals.splice(state.modals.findIndex(m => m.id === id), 1);
        },
        setModalVisibility(state, {id, show}) {
            const modalToSet = state.modals.find(m => m.id === id);
            modalToSet.show = show;
        },
        updateModal(state, modalData) {
            const target = state.modals.find(m => m.id === modalData.id);
            for (let key in modalData) {
                target[key] = modalData[key];
            }
        },
        setModalState(state, {id, data}) {
            const newData = _.cloneDeep(data);
            state.modalsState[id] = newData;
        }
    },
    actions   : {
        async openModalByName({commit, dispatch, state}, {name,data}) {
            const id = await dispatch('openModal',{
                ...state.availableModals[name],
                ...data
            });
            return id;
        },
        openModal({commit}, modalData) {
            const id = 'modal_' + uuid.v4();
            commit('pushModal', {id, ...modalData, show: true});
            if (modalData.model) {
                let model = modalData.model;
                if(_.isFunction(modalData.model))
                    model = model();
                commit('setModalState', {id, data: model});
            }
            return id;
        },
        closeModal({commit}, modalId) {
            commit('deleteModal', modalId);
        },
        showModal({commit}, id) {
            commit('setModalVisibility', {id, show: true});
        },
        hideModal({commit}, id) {
            commit('setModalVisibility', {id, show: false});
        },
        async focusModal({commit, state, dispatch}, id) {
            await dispatch('hideModal', id);
            await dispatch('showModal', id);
        }
    }
}
